import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
export default function RestartIcon(props) {
  return (
    <SvgIcon title="Restart Video" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM14.6695 10C14.6695 7.23889 12.3927 5 9.58475 5C6.77684 5 4.5 7.23889 4.5 10C4.5 12.7611 6.77684 15 9.58475 15C10.9689 15 12.2288 14.45 13.1441 13.5667L12.3418 12.7833C11.6299 13.4667 10.6582 13.8889 9.58475 13.8889C7.40395 13.8889 5.62994 12.1444 5.62994 10C5.62994 7.85556 7.40395 6.11111 9.58475 6.11111C11.7655 6.11111 13.5395 7.85556 13.5395 10C13.5395 10.0167 13.5381 10.0319 13.5367 10.0472C13.5353 10.0625 13.5339 10.0778 13.5339 10.0944L12.5056 9.08333L11.709 9.86667L14.1045 12.2222L16.5 9.86667L15.7034 9.08333L14.6638 10.1056C14.6638 10.0854 14.6654 10.0667 14.6668 10.0487C14.6682 10.032 14.6695 10.016 14.6695 10Z"
      />
    </SvgIcon>
  );
}
